import * as actions from '../actions/reQuotation';

const INITIAL_STATE = {
  loading: false,
  response: {},
  isError: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.REQUEST_POST_RE_QUOTATION:
      return {
        ...state,
        loading: true,
        response: {},
        isError: false,
      };
    case actions.SUCCESS_POST_RE_QUOTATION:
      return {
        ...state,
        loading: false,
        response: action.payload,
        isError: false,
      };
    case actions.FAILURE_POST_RE_QUOTATION:
      return {
        ...state,
        loading: false,
        response: action.payload,
        isError: true,
      };
    case actions.RESET_RE_QUOTATION:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
};

// selectors
export const getReQuotation = (state) => state.reQuotation;
